"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var forms_html_1 = __importDefault(require("./forms.html"));
var forms_controller_1 = __importDefault(require("./forms.controller"));
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.admin.forms", {
        url: "/forms",
        controller: "AdminFormsController",
        controllerAs: "vm",
        template: forms_html_1.default,
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("drivecoach.admin.forms", [])
    .config(config)
    .controller("AdminFormsController", forms_controller_1.default);
